import { CheckOutlined, CloseOutlined, LineOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

function isValidTime(value) {
  const timeRegex = /^([01]?\d|2[0-3]):[0-5]\d$/;
  return timeRegex.test(value);
}

function formatTime(value) {
  if (!value) return '';
  const [h, m] = value.split(':');
  const hh = h.padStart(2, '0');
  const mm = m.padStart(2, '0');
  return `${hh}:${mm}`;
}

export default function InputTime({ value, onChange, ...props }) {
  const [text, setText] = useState('');

  const isValid = useMemo(() => isValidTime(text), [text]);
  const isNull = useMemo(() => text === '', [text]);

  useEffect(() => {
    if (typeof value === 'string' && value.includes('T')) {
      const time = value.split('T')[1]?.substring(0, 5);
      setText(time || '');
    } else {
      setText(formatTime(value || ''));
    }
  }, [value]);

  const handleBlur = (e) => {
    const val = e.target.value;
    if (isValidTime(val)) {
      onChange?.(formatTime(val));
    } else {
      setText(formatTime(value || ''));
    }
  };

  const handleChange = (e) => {
    let val = e.target.value.replace(/[^\d:]/g, '');
    if (/^\d{4}$/.test(val)) {
      val = `${val.slice(0, 2)}:${val.slice(2)}`;
    }

    setText(val);
  };

  const handleFocus = (e) => {
    const target = e.target;
    setImmediate(() => target.setSelectionRange(0, target.value.length));
  };

  const suffix = isNull ? <LineOutlined /> : isValid ? <CheckOutlined className="success" /> : <CloseOutlined className="error" />;

  return <Input placeholder="HH:MM" onBlur={handleBlur} onChange={handleChange} onFocus={handleFocus} value={text} suffix={suffix} maxLength={5} {...props} />;
}

InputTime.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};
